export default __webpack_public_path__ + "static/media/promos-icon-active.d2460ff6.webp";